import { render, staticRenderFns } from "./CabangView.vue?vue&type=template&id=3bba6b0f&"
import script from "./CabangView.vue?vue&type=script&lang=js&"
export * from "./CabangView.vue?vue&type=script&lang=js&"
import style0 from "./CabangView.vue?vue&type=style&index=0&id=3bba6b0f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports